module.exports = __webpack_public_path__ + "img/pile-of-poo.06d422f7.png";